import { jsxs as r, jsx as t } from "react/jsx-runtime";
function a() {
  return /* @__PURE__ */ r("svg", { viewBox: "0 0 24 24", children: [
    /* @__PURE__ */ t("path", { d: "M3.75,13.36l-.9-.42A10.09,10.09,0,0,1,12.1,7.15v1A9.12,9.12,0,0,0,3.75,13.36Z" }),
    /* @__PURE__ */ t("path", { d: "M20.45,13.36A9.12,9.12,0,0,0,12.1,8.15v-1a10.09,10.09,0,0,1,9.25,5.79Z" }),
    /* @__PURE__ */ t("circle", { cx: "11.9", cy: "12.95", r: "3.6" }),
    /* @__PURE__ */ t(
      "rect",
      {
        x: "9.5",
        y: "2.2",
        width: "2",
        height: "21",
        transform: "translate(-5.9 11.09) rotate(-44.81)"
      }
    ),
    /* @__PURE__ */ t(
      "rect",
      {
        fill: "#fff",
        x: "10.95",
        y: "0.75",
        width: "2",
        height: "21",
        transform: "translate(-4.45 11.8) rotate(-45.19)"
      }
    )
  ] });
}
export {
  a as default
};
